import React ,{useState} from "react";
import Map from "../../components/map/fromLoc";
import Navbar from "../../components/navbar";
export default function MapPage() {
    const [address, setAddress] = useState(null);
    
    return (
        <>
            <Navbar Detatil="ثبت مبدا" Button="/dashboard" value={true} setAddress={setAddress}/>
            <Map loc={address}/>
        </>

    )
}